/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} No_Logs_Found_DescInputs */

const en_no_logs_found_desc = /** @type {(inputs: No_Logs_Found_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No activity logs found for the current selection. Business operations are currently static.`)
};

const es_no_logs_found_desc = /** @type {(inputs: No_Logs_Found_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se encontraron registros de actividad para la selección. Las operaciones comerciales están estáticas.`)
};

const fr_no_logs_found_desc = /** @type {(inputs: No_Logs_Found_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucun journal d'activité trouvé pour la sélection actuelle. Les opérations commerciales sont actuellement statiques.`)
};

const de_no_logs_found_desc = /** @type {(inputs: No_Logs_Found_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keine Aktivitätsprotokolle für die aktuelle Auswahl gefunden. Die Geschäftsabläufe sind derzeit statisch.`)
};

const id_no_logs_found_desc = /** @type {(inputs: No_Logs_Found_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tidak ada log aktivitas ditemukan untuk pilihan saat ini. Operasi bisnis sedang statis.`)
};

/** @type {(inputs: No_Logs_Found_DescInputs) => LocalizedString} */
const ja_no_logs_found_desc = en_no_logs_found_desc;

/** @type {(inputs: No_Logs_Found_DescInputs) => LocalizedString} */
const zh_no_logs_found_desc = en_no_logs_found_desc;

/** @type {(inputs: No_Logs_Found_DescInputs) => LocalizedString} */
const ar_no_logs_found_desc = en_no_logs_found_desc;

/** @type {(inputs: No_Logs_Found_DescInputs) => LocalizedString} */
const it_no_logs_found_desc = en_no_logs_found_desc;

/** @type {(inputs: No_Logs_Found_DescInputs) => LocalizedString} */
const ru_no_logs_found_desc = en_no_logs_found_desc;

/** @type {(inputs: No_Logs_Found_DescInputs) => LocalizedString} */
const pt_no_logs_found_desc = en_no_logs_found_desc;

/** @type {(inputs: No_Logs_Found_DescInputs) => LocalizedString} */
const ko_no_logs_found_desc = en_no_logs_found_desc;

/**
* | output |
* | --- |
* | "No activity logs found for the current selection. Business operations are currently static." |
*
* @param {No_Logs_Found_DescInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const no_logs_found_desc = /** @type {((inputs?: No_Logs_Found_DescInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<No_Logs_Found_DescInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_no_logs_found_desc(inputs)
	if (locale === "es") return es_no_logs_found_desc(inputs)
	if (locale === "fr") return fr_no_logs_found_desc(inputs)
	if (locale === "de") return de_no_logs_found_desc(inputs)
	if (locale === "ja") return ja_no_logs_found_desc(inputs)
	if (locale === "zh") return zh_no_logs_found_desc(inputs)
	if (locale === "ar") return ar_no_logs_found_desc(inputs)
	if (locale === "id") return id_no_logs_found_desc(inputs)
	if (locale === "it") return it_no_logs_found_desc(inputs)
	if (locale === "ru") return ru_no_logs_found_desc(inputs)
	if (locale === "pt") return pt_no_logs_found_desc(inputs)
	return ko_no_logs_found_desc(inputs)
});